import dbPromise from './indexedDB';

export const storeImageInCache = async (key, imageBlob) => {
  const db = await dbPromise;
  const tx = db.transaction('images', 'readwrite');
  const store = tx.objectStore('images');
  await store.put(imageBlob, key);
  await tx.done;
};

export const getImageFromCache = async (key) => {
  const db = await dbPromise;
  const tx = db.transaction('images', 'readonly');
  const store = tx.objectStore('images');
  const imageBlob = await store.get(key);
  await tx.done;
  return imageBlob;
};

export const initImageStore = async () => {
  await dbPromise; // Ensures the DB opens and creates the store
};
